module.exports = __webpack_public_path__ + "img/adv-mapIcon21.c4d64fc8.png";